import React from 'react';

interface PageTitleProps {
  children: React.ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({ children }) => (
  <h2 className='sg-u-type-h1'>{children}</h2>
);
